import { useSelector, shallowEqual } from 'react-redux';
import moment from 'moment';

import { NsAlert } from 'components/common/ns-alert/NsAlert';
import { selectMoveInDate } from 'state/move-in-date/move-in-date-slice';
import { DATE_FORMAT } from 'config/app-config';

export const testId = 'moveInPreSSDErrorTestId';

type MoveInPreSSDErrorProps = {
  title?: string;
};

export const MoveInPreSSDError = ({ title }: MoveInPreSSDErrorProps) => {
  const moveInDate = useSelector(selectMoveInDate, shallowEqual);
  const formattedMoveInDate = moment(moveInDate, DATE_FORMAT, true).format(
    'Do MMMM YYYY'
  );

  return (
    <NsAlert state="info" heading={title} testId={testId}>
      <p>
        We’ve updated the date to the <b>{formattedMoveInDate}</b>, which is the
        earliest we can set up your account.
      </p>
      <p>
        Any energy used before this date will be billed by your previous
        supplier.
      </p>
      <p>If you’re happy with this, please proceed to the next step.</p>
    </NsAlert>
  );
};
